export default {
  // Resources
  loginResource: '/auth/login',
  registerResource: '/auth/register',
  refreshResource: '/auth/refresh',
  logoutResource: '/auth/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storag
  storageUserDataKeyName: 'userData',
  storageTokenKeyName: 'token',
  storageRefreshTokenKeyName: 'refreshToken',
}
